import http from "../utils/http";
import store from "../store";
const api = {
  /* export function fetchPermission(){
    return axios.get("/api/permission?user=" + store.state.UserToken);
}

export function login(user){
    return axios.get("/api/login?user=" + user)
} */
};

//增
export function insertData(params) {
  var res = http.post("/api/CheckInvoice/AddInvoice", params);
  return res;
}
//删
export function delData(params) {
  var res = http.delete("/api/CheckInvoice/DelInvoice?number=" + params);
  return res;
}
//查
export function getData(params) {
  const url=`${"/api/CheckInvoice/InvoiceInfo"}?code=${params.code}&number=${params.number}`;
  var res = http.get(url);
  return res;
}
//查记录
export function queryInvoiceRecord(params) {
  const url=`${"/api/CheckInvoice/QueryInvoiceRecord"}?date=${params.date}&unit=${params.unit}&type=${params.type}`;
  //console.log(url);
  var res = http.get(url);
  return res;
}
//用手机号验证码登录
export function loginByPhoneAndCode(params) {
  var res = http.post("/api/user/LoginByPhoneAndCode", params);
  return res;
}
//发送验证码
export function getPhoneCode(params) {
  var res = http.get("/api/user/GetPoneCode?phone=" + params.phoneNo);
  return res;
}
//登录
export function login(user) {
  let rst = axios.post("/api/User/login", user);
  return rst;
}
//验证登录
export function validate(params) {
  let per = axios.get(
    "/api/User/Validate?user_token",params);
  return per;
}
//获取用户权限
export function fetchPermission() {
  let per = axios.get(
    "/api/User/GetUserPermission?user_token=" + store.state.token
  );
  return per;
}

export default api;
